import React from 'react';
import {
    WarnModalOverlay,
    ModalContainer,
    ModalCloseButton,
    FormH1
} from './WarnModalElements';

const WarnModal = ({ isOpen, onClose }) => {

    if (!isOpen) return null;

    return (
        <WarnModalOverlay>
            <ModalContainer>
                <FormH1>Due to Charles Schwab policy, if you link a Schwab account, you must explicitly enable thinkorswim features on their platform before external API trading is permitted. Before continuing ensure Thinkorswim is enabled through your Charles Schwab account page or by visiting https://trade.thinkorswim.com/.</FormH1>
                <ModalCloseButton onClick={(e) => onClose(e)}>Close</ModalCloseButton>
            </ModalContainer>
        </WarnModalOverlay>
    );
};


export default WarnModal;
